import { del, get, post, put } from "../../src/middleware/heplers/api_helper";
import * as url from "../middleware/heplers/url_hepler";
import axios from "axios";

// Admin Login
export const loginAdmin = (email, password) =>
  post(url.POST_ADMIN_LOGIN, { email, password });

// Agent Login
export const loginAgent = (data) => post(url.POST_AGENT_LOGIN, data);

// Admin Logout
export const logout = () => post(url.POST_ADMIN_LOGOUT);

// Create Agent
export const createAgent = (data) => post(url.CREATE_AGENT, data);

// Update Agent
export const updateAgent = (agentId, data) =>
  put(`${url.UPDATE_AGENT}/${agentId}`, data);

// Delete Agent
export const deleteAgent = (agentId) => del(`${url.DELETE_AGENT}/${agentId}`);

// Get All Agents
export const getAllAgents = () => get(url.GET_ALL_AGENTS);

// Get Agent by ID
export const getAgentById = (agentId) =>
  get(`${url.GET_AGENT_BY_ID}/${agentId}`);

export const getLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    return await get(
      `${url.GET_ALL_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}/${storedAdminName}`
    );
  }
  throw new Error("Admin ID or Role not found in localStorage");
};

export const getLoansCountByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    return await get(
      `${url.GET_ALL_LOANS_COUNT_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}/${storedAdminName}`
    );
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
// Get Admin by ID
export const getAdminById = (adminId) =>
  get(`${url.GET_ADMIN_BY_ID}/${adminId}`);

// Create Admin
export const createAdmin = (data) => post(url.CREATE_ADMIN, data);

// Update Admin
export const updateAdmin = (adminId, data) =>
  put(`${url.UPDATE_ADMIN}/${adminId}`, data);

// Update Admin
export const deleteCustomer = (adminId) =>
  post(`${url.DELETE_CUSTOMER}/${adminId}`);

// Update Admin Password
export const UpdatePassword = (adminId, data) =>
  put(`${url.UPDATE_PASSWORD}/${adminId}`, data);

// Forgot Password
export const forgotPassword = (email) => post(url.FORGOT_PASSWORD, { email });

// Get All Admins
export const getAllAdmins = () => get(url.GET_ALL_ADMINS);

// Get Email
export const getAdminByEmail = (email) =>
  get(`${url.GET_ADMIN_BY_EMAIL}/${email}`);

// Get Email
export const getAdminByMobile = (mobile) =>
  get(`${url.GET_ADMIN_BY_MOBILE}/${mobile}`);

// Get All Cities
export const getAllCities = () => get(url.GET_ALL_CITIES);

// Get All States
export const getAllStates = () => get(url.GET_ALL_STATES);

// Get All Pincodes
export const getAllPincode = () => get(url.GET_ALL_PINCODES);

// Business Loans
export const createBusinessLoan = (data) =>
  post(url.CREATE_BUSINESS_LOAN, data);
export const updateBusinessLoan = (loanId, data) =>
  put(`${url.UPDATE_BUSINESS_LOAN}/${loanId}`, data);
export const deleteBusinessLoan = (loanId) =>
  del(`${url.DELETE_BUSINESS_LOAN}/${loanId}`);
export const getAllBusinessLoans = () => get(url.GET_ALL_BUSINESS_LOANS);
export const getBusinessLoanById = (loanId) =>
  get(`${url.GET_BUSINESS_LOAN_BY_ID}/${loanId}`);
export const getBusinessLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_BUSINESS_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getBusinessLoanByEmail = (email) =>
  get(`${url.GET_BUSINESS_LOAN_BY_EMAIL}/${email}`);
export const getBusinessLoanByMobile = (mobile) =>
  get(`${url.GET_BUSINESS_LOAN_BY_MOBILE}/${mobile}`);

// Car Loans
export const createCarLoan = (data) => post(url.CREATE_CAR_LOAN, data);
export const updateCarLoan = (loanId, data) =>
  put(`${url.UPDATE_CAR_LOAN}/${loanId}`, data);
export const deleteCarLoan = (loanId) =>
  del(`${url.DELETE_CAR_LOAN}/${loanId}`);
export const getAllCarLoans = () => get(url.GET_ALL_CAR_LOANS);
export const getCarLoanById = (loanId) =>
  get(`${url.GET_CAR_LOAN_BY_ID}/${loanId}`);
export const getCarLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_CAR_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}/${storedAdminName}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getCarLoanByEmail = (email) =>
  get(`${url.GET_CAR_LOAN_BY_EMAIL}/${email}`);
export const getCarLoanByMobile = (mobile) =>
  get(`${url.GET_CAR_LOAN_BY_MOBILE}/${mobile}`);

// Home Loans
export const createHomeLoan = (data) => post(url.CREATE_HOME_LOAN, data);
export const updateHomeLoan = (loanId, data) =>
  put(`${url.UPDATE_HOME_LOAN}/${loanId}`, data);
export const deleteHomeLoan = (loanId) =>
  del(`${url.DELETE_HOME_LOAN}/${loanId}`);
export const getHomeLoanById = (loanId) =>
  get(`${url.GET_HOME_LOAN_BY_ID}/${loanId}`);
export const getHomeLoanByEmail = (email) =>
  get(`${url.GET_HOME_LOAN_BY_EMAIL}/${email}`);
export const getHomeLoansByAdminIdAndRole = async (adminName) => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_HOME_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getHomeLoanByMobile = (mobile) =>
  get(`${url.GET_HOME_LOAN_BY_MOBILE}/${mobile}`);

// Credit Card Loans
export const createCreditCardLoan = (data) =>
  post(url.CREATE_CREDIT_CARD_LOAN, data);
export const updateCreditCardLoan = (loanId, data) =>
  put(`${url.UPDATE_CREDIT_CARD_LOAN}/${loanId}`, data);
export const deleteCreditCardLoan = (loanId) =>
  del(`${url.DELETE_CREDIT_CARD_LOAN}/${loanId}`);
export const getAllCreditCardLoans = () => get(url.GET_ALL_CREDIT_CARD_LOANS);
export const getCreditCardLoanById = (loanId) =>
  get(`${url.GET_CREDIT_CARD_LOAN_BY_ID}/${loanId}`);
export const getCreditCardLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_CREDIT_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getCreditCardLoanByEmail = (email) =>
  get(`${url.GET_CREDIT_CARD_LOAN_BY_EMAIL}/${email}`);
export const getCreditCardLoanByMobile = (mobile) =>
  get(`${url.GET_CREDIT_CARD_LOAN_BY_MOBILE}/${mobile}`);

// Insurance Loans
export const createInsuranceLoan = (data) =>
  post(url.CREATE_INSURANCE_LOAN, data);
export const updateInsuranceLoan = (loanId, data) =>
  put(`${url.UPDATE_INSURANCE_LOAN}/${loanId}`, data);
export const deleteInsuranceLoan = (loanId) =>
  del(`${url.DELETE_INSURANCE_LOAN}/${loanId}`);
export const getAllInsuranceLoans = () => get(url.GET_ALL_INSURANCE_LOANS);
export const getInsuranceLoanById = (loanId) =>
  get(`${url.GET_INSURANCE_LOAN_BY_ID}/${loanId}`);
export const getInsuranceLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_INSURANCE_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getInsuranceLoanByEmail = (email) =>
  get(`${url.GET_INSURANCE_LOAN_BY_EMAIL}/${email}`);
export const getInsuranceLoanByMobile = (mobile) =>
  get(`${url.GET_INSURANCE_LOAN_BY_MOBILE}/${mobile}`);

// Mortgage Loans
export const createMortgageLoan = (data) =>
  post(url.CREATE_MORTGAGE_LOAN, data);
export const updateMortgageLoan = (loanId, data) =>
  put(`${url.UPDATE_MORTGAGE_LOAN}/${loanId}`, data);
export const deleteMortgageLoan = (loanId) =>
  del(`${url.DELETE_MORTGAGE_LOAN}/${loanId}`);
export const getAllMortgageLoans = () => get(url.GET_ALL_MORTGAGE_LOANS);
export const getMortgageLoanById = (loanId) =>
  get(`${url.GET_MORTGAGE_LOAN_BY_ID}/${loanId}`);
export const getMortgageLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
      if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_MORTGAGE_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getMortgageLoanByEmail = (email) =>
  get(`${url.GET_MORTGAGE_LOAN_BY_EMAIL}/${email}`);
export const getMortgageLoanByMobile = (mobile) =>
  get(`${url.GET_MORTGAGE_LOAN_BY_MOBILE}/${mobile}`);

// Personal Loans
export const createPersonalLoan = (data) =>
  post(url.CREATE_PERSONAL_LOAN, data);
export const updatePersonalLoan = (loanId, data) =>
  put(`${url.UPDATE_PERSONAL_LOAN}/${loanId}`, data);
export const deletePersonalLoan = (loanId) =>
  del(`${url.DELETE_PERSONAL_LOAN}/${loanId}`);
export const getAllPersonalLoans = () => get(url.GET_ALL_PERSONAL_LOANS);
export const getPersonalLoanById = (loanId) =>
  get(`${url.GET_PERSONAL_LOAN_BY_ID}/${loanId}`);
export const getPersonalLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_PERSONAL_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getPersonalLoanByEmail = (email) =>
  get(`${url.GET_PERSONAL_LOAN_BY_EMAIL}/${email}`);
export const getPersonalLoanByMobile = (mobile) =>
  get(`${url.GET_PERSONAL_LOAN_BY_MOBILE}/${mobile}`);

export const sendOtp = (data) => post(url.SEND_OTP, data);
export const verifyOtp = ({ mobile, otp }) => {
  return axios.get(`${url.VERIFY_OTP}?otp=${otp}&mobile=${mobile}`);
};
export const resendOtp = ({ mobile, otp }) => {
  return axios.get(`${url.RESEND_OTP}?&mobile=${mobile}`);
};

// Doctor Loans
export const createDoctorLoan = (data) => post(url.CREATE_DOCTOR_LOAN, data);
export const updateDoctorLoan = (loanId, data) =>
  put(`${url.UPDATE_DOCTOR_LOAN}/${loanId}`, data);
export const deleteDoctorLoan = (loanId) =>
  del(`${url.DELETE_DOCTOR_LOAN}/${loanId}`);

export const getAllDoctorLoans = () => get(url.GET_ALL_DOCTOR_LOANS);
export const getDoctorLoanById = (loanId) =>
  get(`${url.GET_DOCTOR_LOAN_BY_ID}/${loanId}`);
export const getDoctorLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_DOCTOR_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getDoctorLoanByEmail = (email) =>
  get(`${url.GET_DOCTOR_LOAN_BY_EMAIL}/${email}`);
export const getDoctorLoanByMobile = (mobile) =>
  get(`${url.GET_DOCTOR_LOAN_BY_MOBILE}/${mobile}`);

// NRI Loans
export const createNriLoan = (data) => post(url.CREATE_NRI_LOAN, data);
export const updateNriLoan = (loanId, data) =>
  put(`${url.UPDATE_NRI_LOAN}/${loanId}`, data);
export const deleteNriLoan = (loanId) =>
  del(`${url.DELETE_NRI_LOAN}/${loanId}`);
export const getAllNriLoans = () => get(url.GET_ALL_NRI_LOANS);
export const getNriLoanById = (loanId) =>
  get(`${url.GET_NRI_LOAN_BY_ID}/${loanId}`);
export const getNriLoansByAdminIdAndRole = async () => {
  const storedAdminId = localStorage.getItem("adminId");
  const storedAdminRole = localStorage.getItem("adminRole");
  const storedAdminName = localStorage.getItem("adminName");
  if (storedAdminId && storedAdminRole) {
    let apiUrl = `${url.GET_NRI_LOAN_BY_ADMIN_ID}/${storedAdminId}/${storedAdminRole}`;

    // Append adminName only if exists
    if (storedAdminName && storedAdminName !== "null") {
      apiUrl += `/${storedAdminName}`;
    }

    return await get(apiUrl);
  }
  throw new Error("Admin ID or Role not found in localStorage");
};
export const getNriLoanByEmail = (email) =>
  get(`${url.GET_NRI_LOAN_BY_EMAIL}/${email}`);
export const getNriLoanByMobile = (mobile) =>
  get(`${url.GET_NRI_LOAN_BY_MOBILE}/${mobile}`);

// Bank
export const createBank = (data) => post(url.CREATE_BANK, data);
export const updateBank = (bankId, data) =>
  put(`${url.UPDATE_BANK}/${bankId}`, data);
export const getAllBanks = () => get(url.GET_ALL_BANKS);
export const deleteBank = (bankId) => del(`${url.DELETE_BANK}/${bankId}`);
export const getBankById = (bankId) => get(`${url.GET_BANK_ID}/${bankId}`);
export const getAssignedBanks = (bankId) =>
  get(`${url.GET_BANK_IDS}/${bankId}`);

//Company
export const createCompany = (data) => post(url.CREATE_COMPANY, data);
export const updateCompany = (companyId, data) =>
  put(`${url.UPDATE_COMPANY}/${companyId}`, data);
export const deleteCompany = (companyId) =>
  del(`${url.DELETE_COMPANY}/${companyId}`);
export const getAllCompanies = () => get(url.GET_ALL_COMPANIES);
export const getCompanyById = (companyId) =>
  get(`${url.GET_COMPANY_BY_ID}/${companyId}`);
export const getCompanyByIdWithBanks = (companyId) =>
  get(`${url.GET_COMPANY_BANK_IDS}/${companyId}`);

//Company Based Banks URLs
export const getAllHomeLoanBanks = (companyId) =>
  get(`${url.GET_ALL_HOME_LOAN_BANKS}/${companyId}`);
export const getAllPersonalLoanBanks = (companyId) =>
  get(`${url.GET_ALL_PERSONAL_LOAN_BANKS}/${companyId}`);
export const getAllCarLoanBanks = (companyId) =>
  get(`${url.GET_ALL_CAR_LOAN_BANKS}/${companyId}`);
export const getAllMortgageLoanBanks = (companyId) =>
  get(`${url.GET_ALL_MORTGAGE_LOAN_BANKS}/${companyId}`);
export const getAllCreditCardLoanBanks = (companyId) =>
  get(`${url.GET_ALL_CREDIT_CARD_LOAN_BANKS}/${companyId}`);
export const getAllInsuranceLoanBanks = (companyId) =>
  get(`${url.GET_ALL_INSURANCE_LOAN_BANKS}/${companyId}`);
export const getAllNriLoanBanks = (companyId) =>
  get(`${url.GET_ALL_NRI_LOAN_BANKS}/${companyId}`);

// Bulk Company 
export const bulkUploadCompanies = (data) =>
  post(url.BULK_UPLOAD_COMPANIES, data);
export const bulkDeleteCompanies = (data) =>
  post(url.BULK_DELETE_COMPANIES, data);

// Loan Based All Banks
export const getBusinessLoanBankList = () => get(url.GET_BUSINESS_LOAN_BANK_LIST);
export const getDoctorLoanBankList = () => get(url.GET_DOCTOR_LOAN_BANK_LIST);
export const getHomeLoanBankList = () => get(url.GET_HOME_LOAN_BANK_LIST);
export const getPersonalLoanBankList = () => get(url.GET_PERSONAL_LOAN_BANK_LIST);
export const getMortgageLoanBankList = () => get(url.GET_MORTGAGE_LOAN_BANK_LIST);
export const getNriLoanBankList = () => get(url.GET_NRI_LOAN_BANK_LIST);

//Mobile OTP Login
export const mobileOTPLogin = (mobile) => post(url.POST_MOBILE_LOGIN, { mobile });
export const createOrGetCustomer= (data) => post(url.CREATE_OR_GET_CUSTOMER, data);